import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
/*
 * EV User Retrieval API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.44
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";
import { CitedBy } from "../modelrest/CitedBy";
import { CitedByCountAndAuthors } from "../modelrest/CitedByCountAndAuthors";
import { CitedByCountRequest } from "../modelrest/CitedByCountRequest";
import { CitedByCountResponse } from "../modelrest/CitedByCountResponse";
import { CitedByResponse } from "../modelrest/CitedByResponse";
import { SearchesEntityBean } from "../modelrest/SearchesEntityBean";

/**
 * EvRetrieval service.
 * @module api/EvRetrievalApi
 * @version 1.0
 */
export var EvRetrievalApi = /*#__PURE__*/function () {
  /**
    * Constructs a new EvRetrievalApi. 
    * @alias module:api/EvRetrievalApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
  function EvRetrievalApi(apiClient) {
    _classCallCheck(this, EvRetrievalApi);
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * @param {Array.<module:modelrest/CitedBy>} body
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:modelrest/CitedByResponse>} and HTTP response
   */
  _createClass(EvRetrievalApi, [{
    key: "citedByCountWithHttpInfo",
    value: function citedByCountWithHttpInfo(body) {
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling citedByCount");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = [CitedByResponse];
      return this.apiClient.callApi("/rest/toolsinscopus/citedbycount", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:modelrest/CitedByResponse>}
     */
  }, {
    key: "citedByCount",
    value: function citedByCount(body) {
      return this.citedByCountWithHttpInfo(body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {module:modelrest/CitedBy} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:modelrest/CitedByCountAndAuthors} and HTTP response
     */
  }, {
    key: "citedByCountAndAuthorsWithHttpInfo",
    value: function citedByCountAndAuthorsWithHttpInfo(body) {
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling citedByCountAndAuthors");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = CitedByCountAndAuthors;
      return this.apiClient.callApi("/rest/toolsinscopus/citedbycountandauthors", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:modelrest/CitedByCountAndAuthors}
     */
  }, {
    key: "citedByCountAndAuthors",
    value: function citedByCountAndAuthors(body) {
      return this.citedByCountAndAuthorsWithHttpInfo(body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {module:modelrest/CitedByCountRequest} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:modelrest/CitedByCountResponse} and HTTP response
     */
  }, {
    key: "citedByCountRawWithHttpInfo",
    value: function citedByCountRawWithHttpInfo(body) {
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling citedByCountRaw");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = CitedByCountResponse;
      return this.apiClient.callApi("/rest/toolsinscopus/citedbycount/raw", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:modelrest/CitedByCountResponse}
     */
  }, {
    key: "citedByCountRaw",
    value: function citedByCountRaw(body) {
      return this.citedByCountRawWithHttpInfo(body).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * new record retrival call
     * @param {Array.<String>} docid
     * @param {Object} opts Optional parameters
     * @param {module:modelrest/String} opts.docFormat
     * @param {String} opts.searchId
     * @param {Number} opts.docIndex
     * @param {String} opts.searchType
     * @param {String} opts.emailAlertWeek
     * @param {Number} opts.resultCount
     * @param {String} opts.usageOrigin
     * @param {String} opts.usageZone
     * @param {String} opts.partnerId
     * @param {String} opts.activity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getRecordWithHttpInfo",
    value: function getRecordWithHttpInfo(docid, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'docid' is set
      if (docid === undefined || docid === null) {
        throw new Error("Missing the required parameter 'docid' when calling getRecord");
      }
      var pathParams = {};
      var queryParams = {
        docid: this.apiClient.buildCollectionParam(docid, "multi"),
        docFormat: opts["docFormat"],
        searchId: opts["searchId"],
        docIndex: opts["docIndex"],
        searchType: opts["searchType"],
        emailAlertWeek: opts["emailAlertWeek"],
        resultCount: opts["resultCount"],
        usageOrigin: opts["usageOrigin"],
        usageZone: opts["usageZone"],
        partnerId: opts["partnerId"],
        activity: opts["activity"]
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = ["application/json"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/doc", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * new record retrival call
     * @param {<&vendorExtensions.x-jsdoc-type>} docid
     * @param {Object} opts Optional parameters
     * @param {module:modelrest/String} opts.docFormat
     * @param {String} opts.searchId
     * @param {Number} opts.docIndex
     * @param {String} opts.searchType
     * @param {String} opts.emailAlertWeek
     * @param {Number} opts.resultCount
     * @param {String} opts.usageOrigin
     * @param {String} opts.usageZone
     * @param {String} opts.partnerId
     * @param {String} opts.activity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getRecord",
    value: function getRecord(docid, opts) {
      return this.getRecordWithHttpInfo(docid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * new record retrival call w/highlight
     * @param {module:modelrest/SearchesEntityBean} body
     * @param {Array.<String>} docid
     * @param {Object} opts Optional parameters
     * @param {module:modelrest/String} opts.docFormat
     * @param {String} opts.searchId
     * @param {Number} opts.docIndex
     * @param {String} opts.searchType
     * @param {String} opts.emailAlertWeek
     * @param {Number} opts.resultCount
     * @param {String} opts.usageOrigin
     * @param {String} opts.usageZone
     * @param {String} opts.partnerId
     * @param {String} opts.activity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getRecordPostWithHttpInfo",
    value: function getRecordPostWithHttpInfo(body, docid, opts) {
      opts = opts || {};
      var postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling getRecordPost");
      }
      // verify the required parameter 'docid' is set
      if (docid === undefined || docid === null) {
        throw new Error("Missing the required parameter 'docid' when calling getRecordPost");
      }
      var pathParams = {};
      var queryParams = {
        docid: this.apiClient.buildCollectionParam(docid, "multi"),
        docFormat: opts["docFormat"],
        searchId: opts["searchId"],
        docIndex: opts["docIndex"],
        searchType: opts["searchType"],
        emailAlertWeek: opts["emailAlertWeek"],
        resultCount: opts["resultCount"],
        usageOrigin: opts["usageOrigin"],
        usageZone: opts["usageZone"],
        partnerId: opts["partnerId"],
        activity: opts["activity"]
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = ["application/json"];
      var accepts = ["application/json"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/doc", "POST", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * new record retrival call w/highlight
     * @param {<&vendorExtensions.x-jsdoc-type>} body
     * @param {<&vendorExtensions.x-jsdoc-type>} docid
     * @param {Object} opts Optional parameters
     * @param {module:modelrest/String} opts.docFormat
     * @param {String} opts.searchId
     * @param {Number} opts.docIndex
     * @param {String} opts.searchType
     * @param {String} opts.emailAlertWeek
     * @param {Number} opts.resultCount
     * @param {String} opts.usageOrigin
     * @param {String} opts.usageZone
     * @param {String} opts.partnerId
     * @param {String} opts.activity
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getRecordPost",
    value: function getRecordPost(body, docid, opts) {
      return this.getRecordPostWithHttpInfo(body, docid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return EvRetrievalApi;
}();